var map = {
	"./assets/audio/surecoin/coin-clatte.mp3": 22801,
	"./assets/audio/surecoin/coin-spill.mp3": 92,
	"./assets/audio/surecoin/coin.mp3": 63761,
	"./assets/audio/surecoin/moneda.mp3": 76876,
	"./assets/audio/surecoin/win-mixkit.wav": 90535,
	"./assets/audio/surecoin/wood-surface-single-coin-payout.mp3": 39593,
	"./assets/css/accordion.react.css": 14536,
	"./assets/css/application.css": 60727,
	"./assets/css/casino.css": 22692,
	"./assets/css/sidebar-menu.css": 59321,
	"./assets/css/surebox.css": 7535,
	"./assets/css/surecoin.css": 50757,
	"./assets/css/tolkits.css": 83527,
	"./assets/fonts/AllerDisplay.ttf": 67089,
	"./assets/fonts/Aller_Bd.ttf": 42194,
	"./assets/fonts/Aller_BdIt.ttf": 94853,
	"./assets/fonts/FontAwesome.otf": 61302,
	"./assets/fonts/GothamBold.eot": 28532,
	"./assets/fonts/GothamBold.svg": 38250,
	"./assets/fonts/GothamBold.ttf": 42494,
	"./assets/fonts/GothamBold.woff": 50750,
	"./assets/fonts/GothamBook.eot": 90786,
	"./assets/fonts/GothamBook.ttf": 35484,
	"./assets/fonts/GothamBook.woff": 90252,
	"./assets/fonts/GothamUltra.eot": 21453,
	"./assets/fonts/GothamUltra.ttf": 38567,
	"./assets/fonts/GothamUltra.woff": 10229,
	"./assets/fonts/Ubuntu-B.ttf": 44367,
	"./assets/fonts/aller_bd-webfont.eot": 61510,
	"./assets/fonts/aller_bd-webfont.ttf": 35680,
	"./assets/fonts/aller_bd-webfont.woff": 81824,
	"./assets/fonts/aller_bdit-webfont.eot": 21477,
	"./assets/fonts/aller_bdit-webfont.ttf": 44303,
	"./assets/fonts/aller_bdit-webfont.woff": 39197,
	"./assets/fonts/aller_it-webfont.eot": 71431,
	"./assets/fonts/aller_it-webfont.ttf": 93401,
	"./assets/fonts/aller_it-webfont.woff": 94303,
	"./assets/fonts/aller_lt-webfont.eot": 99824,
	"./assets/fonts/aller_lt-webfont.ttf": 4394,
	"./assets/fonts/aller_lt-webfont.woff": 74362,
	"./assets/fonts/aller_ltit-webfont.eot": 69559,
	"./assets/fonts/aller_ltit-webfont.ttf": 77897,
	"./assets/fonts/aller_ltit-webfont.woff": 31887,
	"./assets/fonts/aller_rg-webfont.eot": 77589,
	"./assets/fonts/aller_rg-webfont.ttf": 18847,
	"./assets/fonts/aller_rg-webfont.woff": 50221,
	"./assets/fonts/allerdisplay-webfont.eot": 54585,
	"./assets/fonts/allerdisplay-webfont.ttf": 3715,
	"./assets/fonts/allerdisplay-webfont.woff": 32609,
	"./assets/fonts/fontawesome-webfont.eot": 87181,
	"./assets/fonts/fontawesome-webfont.svg": 58279,
	"./assets/fonts/fontawesome-webfont.ttf": 61767,
	"./assets/fonts/fontawesome-webfont.woff": 57653,
	"./assets/fonts/fontawesome-webfont.woff2": 23053,
	"./assets/highlight/JetX.png": 28568,
	"./assets/highlight/aviator-banner-img.webp": 68286,
	"./assets/highlight/aviator.png": 87389,
	"./assets/highlight/aviatrix.gif": 12682,
	"./assets/highlight/comet.png": 10059,
	"./assets/highlight/default.png": 59696,
	"./assets/highlight/liginare.png": 66466,
	"./assets/highlight/virtuals.png": 52095,
	"./assets/img/PayBill.png": 17283,
	"./assets/img/SureBet.Logo.jpg": 77071,
	"./assets/img/Surebet.logo.F.pdf": 64313,
	"./assets/img/Surebet.logo.F.png": 27779,
	"./assets/img/Surebet.logo.F.svg": 47709,
	"./assets/img/Virtual-side-Banner.png": 95968,
	"./assets/img/advertgames/game1.png": 32875,
	"./assets/img/advertgames/game10.png": 23587,
	"./assets/img/advertgames/game11.png": 59482,
	"./assets/img/advertgames/game12.png": 80593,
	"./assets/img/advertgames/game2.png": 67472,
	"./assets/img/advertgames/game3.png": 83225,
	"./assets/img/advertgames/game4.png": 94598,
	"./assets/img/advertgames/game5.png": 63343,
	"./assets/img/advertgames/game6.png": 40884,
	"./assets/img/advertgames/game7.png": 62013,
	"./assets/img/advertgames/game8.png": 85418,
	"./assets/img/advertgames/game9.png": 36179,
	"./assets/img/airtelmoney.png": 16247,
	"./assets/img/banner/App.png": 13322,
	"./assets/img/banner/Breakfast.png": 67208,
	"./assets/img/banner/CashBack.png": 43031,
	"./assets/img/banner/Casino.png": 13070,
	"./assets/img/banner/EPL.png": 59442,
	"./assets/img/banner/Freebet.png": 93588,
	"./assets/img/banner/Live-Betting.png": 37347,
	"./assets/img/banner/Multibet.png": 45535,
	"./assets/img/banner/Sharebet.png": 15501,
	"./assets/img/banner/Tick.png": 33876,
	"./assets/img/banner/Welcome-Bonus.png": 721,
	"./assets/img/banner/aviator-banner.jpg": 17278,
	"./assets/img/banner/carousel/CashBack.png": 14038,
	"./assets/img/banner/carousel/Live-Betting.png": 60446,
	"./assets/img/banner/carousel/Sharebet.png": 48468,
	"./assets/img/banner/carousel/Tick.png": 24561,
	"./assets/img/banner/carousel/Welcome-Bonus.png": 6782,
	"./assets/img/banner/carousel/app.png": 80813,
	"./assets/img/banner/carousel/breakfast.png": 28363,
	"./assets/img/banner/carousel/casino.png": 65759,
	"./assets/img/banner/carousel/jackpot.png": 1402,
	"./assets/img/banner/carousel/moses-epl.png": 44113,
	"./assets/img/banner/carousel/multibet.png": 4070,
	"./assets/img/banner/casino-banner1.jpg": 37546,
	"./assets/img/banner/casino-banner2.jpg": 78037,
	"./assets/img/banner/casino-banner3.jpg": 16856,
	"./assets/img/banner/customer-care/PAYBILL.jpg": 27601,
	"./assets/img/banner/jackpot.png": 12437,
	"./assets/img/banner/jackpots/DailyJackpot.png": 56060,
	"./assets/img/banner/market.png": 97635,
	"./assets/img/banner/print-matches/Footer.png": 38346,
	"./assets/img/banner/print-matches/Header.png": 98084,
	"./assets/img/banner/products/CashBack.png": 99436,
	"./assets/img/banner/products/Deposit-Bonus.png": 41634,
	"./assets/img/banner/products/JackPot.png": 14992,
	"./assets/img/banner/products/Live-Betting.png": 56392,
	"./assets/img/banner/products/Mshipi-Bonus.png": 63102,
	"./assets/img/banner/products/Welcome-Bonus.png": 41432,
	"./assets/img/banner/products/freebet.jpeg": 48110,
	"./assets/img/banner/stock-market.jpg": 47656,
	"./assets/img/betrader/test-game-details.png": 57336,
	"./assets/img/bpl.png": 23312,
	"./assets/img/brazil.png": 50718,
	"./assets/img/bundesliga.png": 59488,
	"./assets/img/casino/aviatrix/aviatrix.jpg": 75363,
	"./assets/img/casino/background1.png": 45881,
	"./assets/img/casino/bg-black.png": 35305,
	"./assets/img/casino/bg-darkgreen.avif": 69021,
	"./assets/img/casino/bg-maroon.avif": 75642,
	"./assets/img/casino/bg-pink.png": 40878,
	"./assets/img/casino/bg-yellow.png": 99490,
	"./assets/img/casino/box.png": 94587,
	"./assets/img/casino/carousel/1.jpg": 87160,
	"./assets/img/casino/carousel/10.png": 16358,
	"./assets/img/casino/carousel/11-old.jpg": 16327,
	"./assets/img/casino/carousel/11.jpg": 27039,
	"./assets/img/casino/carousel/12.jpg": 43312,
	"./assets/img/casino/carousel/13.jpg": 88205,
	"./assets/img/casino/carousel/13.png": 13917,
	"./assets/img/casino/carousel/14.jpg": 88358,
	"./assets/img/casino/carousel/2.png": 70839,
	"./assets/img/casino/carousel/3.png": 27822,
	"./assets/img/casino/carousel/4.png": 63937,
	"./assets/img/casino/carousel/5.jpg": 25948,
	"./assets/img/casino/carousel/6.png": 70163,
	"./assets/img/casino/carousel/7.jpg": 67182,
	"./assets/img/casino/carousel/8.jpg": 82189,
	"./assets/img/casino/carousel/9.png": 27892,
	"./assets/img/casino/carousel/Tick.png": 36226,
	"./assets/img/casino/carousel/intro.png": 49139,
	"./assets/img/casino/close.gif": 59163,
	"./assets/img/casino/closedbox.jpg": 36239,
	"./assets/img/casino/closedbox.png": 60287,
	"./assets/img/casino/closedbox.webp": 62975,
	"./assets/img/casino/closedfullybox.webp": 44067,
	"./assets/img/casino/closedgiftbox.webp": 48741,
	"./assets/img/casino/coin-background.jpg": 50816,
	"./assets/img/casino/coins.mp4": 11027,
	"./assets/img/casino/default.png": 44955,
	"./assets/img/casino/fsurebox/closedbox.jpg": 81256,
	"./assets/img/casino/fsurebox/closedbox.png": 24364,
	"./assets/img/casino/fsurebox/closedbox.webp": 32828,
	"./assets/img/casino/fsurebox/closedfullybox.webp": 63054,
	"./assets/img/casino/fsurebox/openbox.jpg": 16912,
	"./assets/img/casino/fsurebox/openedbox.jpg": 181,
	"./assets/img/casino/fsurebox/openedbox.webp": 38079,
	"./assets/img/casino/head.png": 92988,
	"./assets/img/casino/icons/Aviatrix.svg": 94457,
	"./assets/img/casino/icons/Baccarat New.svg": 21770,
	"./assets/img/casino/icons/Baccarat.svg": 77584,
	"./assets/img/casino/icons/Bingo and Keno.svg": 14708,
	"./assets/img/casino/icons/Bingo.svg": 98592,
	"./assets/img/casino/icons/Blackjack.svg": 9161,
	"./assets/img/casino/icons/Cards.svg": 75112,
	"./assets/img/casino/icons/Cashout.svg": 14582,
	"./assets/img/casino/icons/Classic Slots.svg": 6354,
	"./assets/img/casino/icons/Crash Games.svg": 14429,
	"./assets/img/casino/icons/Crash.svg": 74788,
	"./assets/img/casino/icons/Dice Games.svg": 19983,
	"./assets/img/casino/icons/Dice.svg": 71254,
	"./assets/img/casino/icons/Drops and Wins.svg": 58889,
	"./assets/img/casino/icons/Games.svg": 74544,
	"./assets/img/casino/icons/GamesLobby.svg": 4808,
	"./assets/img/casino/icons/Holdem.svg": 73046,
	"./assets/img/casino/icons/Infinity Play.svg": 86207,
	"./assets/img/casino/icons/Instant Win.svg": 47148,
	"./assets/img/casino/icons/Instant.svg": 11754,
	"./assets/img/casino/icons/JetX.svg": 29256,
	"./assets/img/casino/icons/Keno.svg": 97354,
	"./assets/img/casino/icons/Live games.svg": 38248,
	"./assets/img/casino/icons/Lucky tapper.svg": 5307,
	"./assets/img/casino/icons/Mine.svg": 30606,
	"./assets/img/casino/icons/New.svg": 47119,
	"./assets/img/casino/icons/Others.svg": 73690,
	"./assets/img/casino/icons/Plinko.svg": 41744,
	"./assets/img/casino/icons/Poker.svg": 68290,
	"./assets/img/casino/icons/RGS - VSB.svg": 93077,
	"./assets/img/casino/icons/Roulette.svg": 17055,
	"./assets/img/casino/icons/Scratch card.svg": 75591,
	"./assets/img/casino/icons/Scratchcard.svg": 70681,
	"./assets/img/casino/icons/SetDefault.svg": 69608,
	"./assets/img/casino/icons/Slot copy 2.svg": 35616,
	"./assets/img/casino/icons/Slot.svg": 50119,
	"./assets/img/casino/icons/Slots.svg": 92662,
	"./assets/img/casino/icons/Table and Cards.svg": 41535,
	"./assets/img/casino/icons/Tower.svg": 15242,
	"./assets/img/casino/icons/Video Slots.svg": 29087,
	"./assets/img/casino/icons/Virtuals.svg": 14507,
	"./assets/img/casino/icons/Wheel of Fortune.svg": 87768,
	"./assets/img/casino/icons/XGames.svg": 17698,
	"./assets/img/casino/icons/amarix.svg": 71915,
	"./assets/img/casino/icons/aviatorhome.avif": 50984,
	"./assets/img/casino/icons/aviatrix3.svg": 71768,
	"./assets/img/casino/icons/aviatrixhome.avif": 51162,
	"./assets/img/casino/icons/booming games.svg": 10559,
	"./assets/img/casino/icons/booming.svg": 39494,
	"./assets/img/casino/icons/casinohome.avif": 3955,
	"./assets/img/casino/icons/daemon/peakunifyprinter.xml": 44249,
	"./assets/img/casino/icons/default.svg": 55926,
	"./assets/img/casino/icons/eurovirtuals - Copy.svg": 18504,
	"./assets/img/casino/icons/eurovirtuals.svg": 9852,
	"./assets/img/casino/icons/fazi.png": 37987,
	"./assets/img/casino/icons/fazi.svg": 27827,
	"./assets/img/casino/icons/fazi3.svg": 94010,
	"./assets/img/casino/icons/hacksaw gaming.svg": 53078,
	"./assets/img/casino/icons/home.svg": 53174,
	"./assets/img/casino/icons/iconic21.svg": 18267,
	"./assets/img/casino/icons/ligi-sure.svg": 6616,
	"./assets/img/casino/icons/onlyplay.svg": 16595,
	"./assets/img/casino/icons/platipus.svg": 42207,
	"./assets/img/casino/icons/popular.svg": 6030,
	"./assets/img/casino/icons/pragmatic.svg": 25593,
	"./assets/img/casino/icons/pragmatic3.svg": 99416,
	"./assets/img/casino/icons/smartsoft.svg": 42150,
	"./assets/img/casino/icons/smartsoft3.svg": 23961,
	"./assets/img/casino/icons/spinhome.avif": 63348,
	"./assets/img/casino/icons/split the pot.png": 64323,
	"./assets/img/casino/icons/split the pot.svg": 63965,
	"./assets/img/casino/icons/split the pot3.svg": 4436,
	"./assets/img/casino/icons/stp.svg": 62294,
	"./assets/img/casino/icons/surecoin.svg": 30395,
	"./assets/img/casino/icons/turbo games.svg": 86052,
	"./assets/img/casino/icons/windows-service.exe": 88322,
	"./assets/img/casino/mixkit-cheering.wav": 95343,
	"./assets/img/casino/money-falling.webp": 78172,
	"./assets/img/casino/notes-falling.gif": 74598,
	"./assets/img/casino/openbox.jpg": 97207,
	"./assets/img/casino/openedbox.jpg": 80018,
	"./assets/img/casino/openedbox.webp": 70040,
	"./assets/img/casino/surebox-close.gif": 67122,
	"./assets/img/casino/surebox-loose.mp3": 17161,
	"./assets/img/casino/surebox-lost.gif": 29116,
	"./assets/img/casino/surebox-openbox.mp3": 56856,
	"./assets/img/casino/surebox-track.mp3": 59222,
	"./assets/img/casino/surebox-unlucky.gif": 73777,
	"./assets/img/casino/surebox-win.gif": 73392,
	"./assets/img/casino/surebox-win.mp3": 94653,
	"./assets/img/casino/tail.png": 19500,
	"./assets/img/casino/try-again.gif": 723,
	"./assets/img/casino/vault.png": 17224,
	"./assets/img/casino/wo2.png": 95812,
	"./assets/img/casino/won.png": 94616,
	"./assets/img/casino/won3.png": 4929,
	"./assets/img/clock.png": 67612,
	"./assets/img/colorsvgicons/American Football.svg": 3371,
	"./assets/img/colorsvgicons/Soccer.svg": 59443,
	"./assets/img/colorsvgicons/app.svg": 96391,
	"./assets/img/colorsvgicons/aussie.svg": 36720,
	"./assets/img/colorsvgicons/aviator.svg": 66884,
	"./assets/img/colorsvgicons/baseball.svg": 77354,
	"./assets/img/colorsvgicons/basketball.svg": 39611,
	"./assets/img/colorsvgicons/boxing.svg": 46623,
	"./assets/img/colorsvgicons/casino.svg": 17039,
	"./assets/img/colorsvgicons/cricket.svg": 41691,
	"./assets/img/colorsvgicons/darts.svg": 86048,
	"./assets/img/colorsvgicons/default.png": 70049,
	"./assets/img/colorsvgicons/floorball.svg": 14935,
	"./assets/img/colorsvgicons/handball.svg": 68298,
	"./assets/img/colorsvgicons/home.svg": 74211,
	"./assets/img/colorsvgicons/icehockey.svg": 34656,
	"./assets/img/colorsvgicons/jackpot.svg": 96420,
	"./assets/img/colorsvgicons/league.svg": 12093,
	"./assets/img/colorsvgicons/livescore.svg": 47098,
	"./assets/img/colorsvgicons/livescore1.svg": 54647,
	"./assets/img/colorsvgicons/mma.svg": 10941,
	"./assets/img/colorsvgicons/print.svg": 55131,
	"./assets/img/colorsvgicons/promos.svg": 52966,
	"./assets/img/colorsvgicons/rugby.svg": 45099,
	"./assets/img/colorsvgicons/sports.svg": 82731,
	"./assets/img/colorsvgicons/surecoin.svg": 30738,
	"./assets/img/colorsvgicons/tennis.svg": 45019,
	"./assets/img/colorsvgicons/virtuals.svg": 30078,
	"./assets/img/colorsvgicons/volleyball.svg": 76434,
	"./assets/img/flags-1-1/ac.svg": 47538,
	"./assets/img/flags-1-1/ad.svg": 81469,
	"./assets/img/flags-1-1/ae.svg": 10844,
	"./assets/img/flags-1-1/af.svg": 89871,
	"./assets/img/flags-1-1/ag.svg": 27294,
	"./assets/img/flags-1-1/ai.svg": 97096,
	"./assets/img/flags-1-1/al.svg": 71029,
	"./assets/img/flags-1-1/am.svg": 29044,
	"./assets/img/flags-1-1/ao.svg": 29782,
	"./assets/img/flags-1-1/aq.svg": 89280,
	"./assets/img/flags-1-1/ar.svg": 60179,
	"./assets/img/flags-1-1/as.svg": 81186,
	"./assets/img/flags-1-1/at.svg": 55853,
	"./assets/img/flags-1-1/au.svg": 76140,
	"./assets/img/flags-1-1/aw.svg": 26734,
	"./assets/img/flags-1-1/ax.svg": 79817,
	"./assets/img/flags-1-1/az.svg": 83787,
	"./assets/img/flags-1-1/ba.svg": 8793,
	"./assets/img/flags-1-1/bb.svg": 17418,
	"./assets/img/flags-1-1/bd.svg": 68020,
	"./assets/img/flags-1-1/be.svg": 40629,
	"./assets/img/flags-1-1/bf.svg": 52406,
	"./assets/img/flags-1-1/bg.svg": 16231,
	"./assets/img/flags-1-1/bh.svg": 27760,
	"./assets/img/flags-1-1/bi.svg": 79649,
	"./assets/img/flags-1-1/bj.svg": 70162,
	"./assets/img/flags-1-1/bl.svg": 14620,
	"./assets/img/flags-1-1/bm.svg": 4093,
	"./assets/img/flags-1-1/bn.svg": 49918,
	"./assets/img/flags-1-1/bo.svg": 93647,
	"./assets/img/flags-1-1/bq.svg": 36617,
	"./assets/img/flags-1-1/br.svg": 68506,
	"./assets/img/flags-1-1/bs.svg": 83115,
	"./assets/img/flags-1-1/bt.svg": 78436,
	"./assets/img/flags-1-1/bv.svg": 23526,
	"./assets/img/flags-1-1/bw.svg": 21559,
	"./assets/img/flags-1-1/by.svg": 5329,
	"./assets/img/flags-1-1/bz.svg": 84962,
	"./assets/img/flags-1-1/ca.svg": 36410,
	"./assets/img/flags-1-1/cc.svg": 2840,
	"./assets/img/flags-1-1/cd.svg": 81559,
	"./assets/img/flags-1-1/cefta.svg": 36417,
	"./assets/img/flags-1-1/cf.svg": 54981,
	"./assets/img/flags-1-1/cg.svg": 76964,
	"./assets/img/flags-1-1/ch.svg": 67091,
	"./assets/img/flags-1-1/ci.svg": 52866,
	"./assets/img/flags-1-1/ck.svg": 76352,
	"./assets/img/flags-1-1/cl.svg": 89375,
	"./assets/img/flags-1-1/cm.svg": 51438,
	"./assets/img/flags-1-1/cn.svg": 62157,
	"./assets/img/flags-1-1/co.svg": 26700,
	"./assets/img/flags-1-1/cp.svg": 36347,
	"./assets/img/flags-1-1/cr.svg": 20377,
	"./assets/img/flags-1-1/cu.svg": 36694,
	"./assets/img/flags-1-1/cv.svg": 49653,
	"./assets/img/flags-1-1/cw.svg": 4724,
	"./assets/img/flags-1-1/cx.svg": 61763,
	"./assets/img/flags-1-1/cy.svg": 28722,
	"./assets/img/flags-1-1/cz.svg": 10465,
	"./assets/img/flags-1-1/de.svg": 64311,
	"./assets/img/flags-1-1/default.svg": 4613,
	"./assets/img/flags-1-1/default_flag.svg": 25686,
	"./assets/img/flags-1-1/default_sport.svg": 22126,
	"./assets/img/flags-1-1/dg.svg": 88709,
	"./assets/img/flags-1-1/dj.svg": 28480,
	"./assets/img/flags-1-1/dk.svg": 48081,
	"./assets/img/flags-1-1/dm.svg": 78015,
	"./assets/img/flags-1-1/do.svg": 97933,
	"./assets/img/flags-1-1/dz.svg": 86864,
	"./assets/img/flags-1-1/ea.svg": 58356,
	"./assets/img/flags-1-1/ec.svg": 42742,
	"./assets/img/flags-1-1/ee.svg": 33736,
	"./assets/img/flags-1-1/eg.svg": 7754,
	"./assets/img/flags-1-1/eh.svg": 94429,
	"./assets/img/flags-1-1/en.svg": 75139,
	"./assets/img/flags-1-1/er.svg": 11895,
	"./assets/img/flags-1-1/es-ct.svg": 31374,
	"./assets/img/flags-1-1/es-ga.svg": 65695,
	"./assets/img/flags-1-1/es.svg": 13862,
	"./assets/img/flags-1-1/et.svg": 26953,
	"./assets/img/flags-1-1/eu.svg": 39064,
	"./assets/img/flags-1-1/fi.svg": 13413,
	"./assets/img/flags-1-1/fj.svg": 81638,
	"./assets/img/flags-1-1/fk.svg": 70615,
	"./assets/img/flags-1-1/fm.svg": 51049,
	"./assets/img/flags-1-1/fo.svg": 83755,
	"./assets/img/flags-1-1/fr.svg": 15934,
	"./assets/img/flags-1-1/ga.svg": 63518,
	"./assets/img/flags-1-1/gb-eng.svg": 52146,
	"./assets/img/flags-1-1/gb-nir.svg": 18241,
	"./assets/img/flags-1-1/gb-sct.svg": 18416,
	"./assets/img/flags-1-1/gb-wls.svg": 18534,
	"./assets/img/flags-1-1/gb.svg": 9789,
	"./assets/img/flags-1-1/gd.svg": 79171,
	"./assets/img/flags-1-1/ge.svg": 75858,
	"./assets/img/flags-1-1/gf.svg": 80897,
	"./assets/img/flags-1-1/gg.svg": 89776,
	"./assets/img/flags-1-1/gh.svg": 70343,
	"./assets/img/flags-1-1/gi.svg": 23478,
	"./assets/img/flags-1-1/gl.svg": 83483,
	"./assets/img/flags-1-1/gm.svg": 31018,
	"./assets/img/flags-1-1/gn.svg": 80313,
	"./assets/img/flags-1-1/gp.svg": 83487,
	"./assets/img/flags-1-1/gq.svg": 68846,
	"./assets/img/flags-1-1/gr.svg": 51821,
	"./assets/img/flags-1-1/gs.svg": 4460,
	"./assets/img/flags-1-1/gt.svg": 27027,
	"./assets/img/flags-1-1/gu.svg": 23298,
	"./assets/img/flags-1-1/gw.svg": 66016,
	"./assets/img/flags-1-1/gy.svg": 29222,
	"./assets/img/flags-1-1/hipo.png": 60322,
	"./assets/img/flags-1-1/hk.svg": 64645,
	"./assets/img/flags-1-1/hm.svg": 51339,
	"./assets/img/flags-1-1/hn.svg": 12504,
	"./assets/img/flags-1-1/hr.svg": 43772,
	"./assets/img/flags-1-1/ht.svg": 38386,
	"./assets/img/flags-1-1/hu.svg": 71427,
	"./assets/img/flags-1-1/ic.svg": 51626,
	"./assets/img/flags-1-1/id.svg": 6901,
	"./assets/img/flags-1-1/ie.svg": 61972,
	"./assets/img/flags-1-1/il.svg": 19901,
	"./assets/img/flags-1-1/im.svg": 91356,
	"./assets/img/flags-1-1/in.svg": 70383,
	"./assets/img/flags-1-1/io.svg": 7806,
	"./assets/img/flags-1-1/iq.svg": 43736,
	"./assets/img/flags-1-1/ir.svg": 98923,
	"./assets/img/flags-1-1/is.svg": 93658,
	"./assets/img/flags-1-1/it.svg": 12229,
	"./assets/img/flags-1-1/je.svg": 17261,
	"./assets/img/flags-1-1/jm.svg": 8037,
	"./assets/img/flags-1-1/jo.svg": 83639,
	"./assets/img/flags-1-1/jp.svg": 6192,
	"./assets/img/flags-1-1/ke.svg": 59582,
	"./assets/img/flags-1-1/kg.svg": 24284,
	"./assets/img/flags-1-1/kh.svg": 87451,
	"./assets/img/flags-1-1/ki.svg": 27082,
	"./assets/img/flags-1-1/km.svg": 62070,
	"./assets/img/flags-1-1/kn.svg": 50293,
	"./assets/img/flags-1-1/kp.svg": 99795,
	"./assets/img/flags-1-1/kr.svg": 14993,
	"./assets/img/flags-1-1/kw.svg": 82252,
	"./assets/img/flags-1-1/ky.svg": 78170,
	"./assets/img/flags-1-1/kz.svg": 46281,
	"./assets/img/flags-1-1/la.svg": 88835,
	"./assets/img/flags-1-1/lb.svg": 99440,
	"./assets/img/flags-1-1/lc.svg": 90561,
	"./assets/img/flags-1-1/li.svg": 93147,
	"./assets/img/flags-1-1/lk.svg": 89977,
	"./assets/img/flags-1-1/lr.svg": 75680,
	"./assets/img/flags-1-1/ls.svg": 90065,
	"./assets/img/flags-1-1/lt.svg": 78510,
	"./assets/img/flags-1-1/lu.svg": 93151,
	"./assets/img/flags-1-1/lv.svg": 14124,
	"./assets/img/flags-1-1/ly.svg": 41003,
	"./assets/img/flags-1-1/ma.svg": 25004,
	"./assets/img/flags-1-1/mc.svg": 75598,
	"./assets/img/flags-1-1/md.svg": 57745,
	"./assets/img/flags-1-1/me.svg": 38144,
	"./assets/img/flags-1-1/mf.svg": 58899,
	"./assets/img/flags-1-1/mg.svg": 37378,
	"./assets/img/flags-1-1/mh.svg": 98373,
	"./assets/img/flags-1-1/mk.svg": 75942,
	"./assets/img/flags-1-1/ml.svg": 89033,
	"./assets/img/flags-1-1/mm.svg": 1144,
	"./assets/img/flags-1-1/mn.svg": 35531,
	"./assets/img/flags-1-1/mo.svg": 20922,
	"./assets/img/flags-1-1/mp.svg": 56509,
	"./assets/img/flags-1-1/mq.svg": 67036,
	"./assets/img/flags-1-1/mr.svg": 46063,
	"./assets/img/flags-1-1/ms.svg": 18686,
	"./assets/img/flags-1-1/mt.svg": 32065,
	"./assets/img/flags-1-1/mu.svg": 96528,
	"./assets/img/flags-1-1/mv.svg": 37219,
	"./assets/img/flags-1-1/mw.svg": 22578,
	"./assets/img/flags-1-1/mx.svg": 93045,
	"./assets/img/flags-1-1/my.svg": 20436,
	"./assets/img/flags-1-1/mz.svg": 68647,
	"./assets/img/flags-1-1/na.svg": 86021,
	"./assets/img/flags-1-1/nc.svg": 74423,
	"./assets/img/flags-1-1/ne.svg": 89481,
	"./assets/img/flags-1-1/nf.svg": 74394,
	"./assets/img/flags-1-1/ng.svg": 93451,
	"./assets/img/flags-1-1/ni.svg": 65517,
	"./assets/img/flags-1-1/nl.svg": 98944,
	"./assets/img/flags-1-1/no.svg": 69843,
	"./assets/img/flags-1-1/np.svg": 38708,
	"./assets/img/flags-1-1/nr.svg": 39446,
	"./assets/img/flags-1-1/nu.svg": 14681,
	"./assets/img/flags-1-1/nz.svg": 36958,
	"./assets/img/flags-1-1/om.svg": 4786,
	"./assets/img/flags-1-1/pa.svg": 51287,
	"./assets/img/flags-1-1/pe.svg": 64427,
	"./assets/img/flags-1-1/pf.svg": 6360,
	"./assets/img/flags-1-1/pg.svg": 31721,
	"./assets/img/flags-1-1/ph.svg": 1934,
	"./assets/img/flags-1-1/pk.svg": 84909,
	"./assets/img/flags-1-1/pl.svg": 72738,
	"./assets/img/flags-1-1/pm.svg": 60115,
	"./assets/img/flags-1-1/pn.svg": 15456,
	"./assets/img/flags-1-1/pr.svg": 55220,
	"./assets/img/flags-1-1/ps.svg": 76853,
	"./assets/img/flags-1-1/pt.svg": 64106,
	"./assets/img/flags-1-1/pw.svg": 13401,
	"./assets/img/flags-1-1/py.svg": 16655,
	"./assets/img/flags-1-1/qa.svg": 61568,
	"./assets/img/flags-1-1/re.svg": 9445,
	"./assets/img/flags-1-1/ro.svg": 80927,
	"./assets/img/flags-1-1/rs.svg": 11547,
	"./assets/img/flags-1-1/ru.svg": 4117,
	"./assets/img/flags-1-1/rw.svg": 49991,
	"./assets/img/flags-1-1/sa.svg": 24938,
	"./assets/img/flags-1-1/sb.svg": 85689,
	"./assets/img/flags-1-1/sc.svg": 77768,
	"./assets/img/flags-1-1/sd.svg": 97575,
	"./assets/img/flags-1-1/se.svg": 10454,
	"./assets/img/flags-1-1/sg.svg": 9716,
	"./assets/img/flags-1-1/sh.svg": 66147,
	"./assets/img/flags-1-1/si.svg": 28210,
	"./assets/img/flags-1-1/sj.svg": 33249,
	"./assets/img/flags-1-1/sk.svg": 21008,
	"./assets/img/flags-1-1/sl.svg": 70543,
	"./assets/img/flags-1-1/sm.svg": 7966,
	"./assets/img/flags-1-1/sn.svg": 62141,
	"./assets/img/flags-1-1/so.svg": 7868,
	"./assets/img/flags-1-1/sr.svg": 60489,
	"./assets/img/flags-1-1/ss.svg": 25624,
	"./assets/img/flags-1-1/st.svg": 45431,
	"./assets/img/flags-1-1/sure.png": 4035,
	"./assets/img/flags-1-1/sv.svg": 57029,
	"./assets/img/flags-1-1/sx.svg": 40851,
	"./assets/img/flags-1-1/sy.svg": 61858,
	"./assets/img/flags-1-1/sz.svg": 32753,
	"./assets/img/flags-1-1/ta.svg": 7355,
	"./assets/img/flags-1-1/tc.svg": 91385,
	"./assets/img/flags-1-1/td.svg": 7702,
	"./assets/img/flags-1-1/tf.svg": 75732,
	"./assets/img/flags-1-1/tg.svg": 20661,
	"./assets/img/flags-1-1/th.svg": 99730,
	"./assets/img/flags-1-1/tj.svg": 66672,
	"./assets/img/flags-1-1/tk.svg": 81473,
	"./assets/img/flags-1-1/tl.svg": 21566,
	"./assets/img/flags-1-1/tm.svg": 84143,
	"./assets/img/flags-1-1/tn.svg": 5116,
	"./assets/img/flags-1-1/to.svg": 33661,
	"./assets/img/flags-1-1/tr.svg": 73848,
	"./assets/img/flags-1-1/tt.svg": 6118,
	"./assets/img/flags-1-1/tv.svg": 47972,
	"./assets/img/flags-1-1/tw.svg": 25989,
	"./assets/img/flags-1-1/tz.svg": 47360,
	"./assets/img/flags-1-1/ua.svg": 45060,
	"./assets/img/flags-1-1/ug.svg": 88154,
	"./assets/img/flags-1-1/um.svg": 12704,
	"./assets/img/flags-1-1/un.svg": 83603,
	"./assets/img/flags-1-1/us.svg": 53206,
	"./assets/img/flags-1-1/uy.svg": 50620,
	"./assets/img/flags-1-1/uz.svg": 13295,
	"./assets/img/flags-1-1/va.svg": 27517,
	"./assets/img/flags-1-1/vc.svg": 17071,
	"./assets/img/flags-1-1/ve.svg": 3073,
	"./assets/img/flags-1-1/vg.svg": 8227,
	"./assets/img/flags-1-1/vi.svg": 64053,
	"./assets/img/flags-1-1/vn.svg": 40842,
	"./assets/img/flags-1-1/vu.svg": 28753,
	"./assets/img/flags-1-1/wf.svg": 56689,
	"./assets/img/flags-1-1/ws.svg": 57532,
	"./assets/img/flags-1-1/xk.svg": 61365,
	"./assets/img/flags-1-1/xx.svg": 67558,
	"./assets/img/flags-1-1/ye.svg": 6500,
	"./assets/img/flags-1-1/yt.svg": 86517,
	"./assets/img/flags-1-1/za.svg": 801,
	"./assets/img/flags-1-1/zm.svg": 39989,
	"./assets/img/flags-1-1/zw.svg": 79711,
	"./assets/img/france.png": 27205,
	"./assets/img/general-website/appstore_badge.svg": 71573,
	"./assets/img/general-website/coming-soon.avif": 39698,
	"./assets/img/general-website/google-play-badge.png": 6465,
	"./assets/img/germany.png": 17129,
	"./assets/img/header-images/1.svg": 17304,
	"./assets/img/header-images/2.svg": 91723,
	"./assets/img/header-images/americanfootball.jpg": 42324,
	"./assets/img/header-images/americanfootball.png": 46128,
	"./assets/img/header-images/americanfootball.svg": 56274,
	"./assets/img/header-images/app.jpg": 21576,
	"./assets/img/header-images/app.svg": 45224,
	"./assets/img/header-images/aussie.jpg": 21155,
	"./assets/img/header-images/aussie.png": 60651,
	"./assets/img/header-images/aussie.svg": 87641,
	"./assets/img/header-images/aviator.png": 37487,
	"./assets/img/header-images/aviator.svg": 32563,
	"./assets/img/header-images/baseball.jpg": 38433,
	"./assets/img/header-images/baseball.svg": 49827,
	"./assets/img/header-images/basketball.svg": 17494,
	"./assets/img/header-images/boxing.jpg": 36144,
	"./assets/img/header-images/boxing.svg": 48118,
	"./assets/img/header-images/casino-direct.png": 5928,
	"./assets/img/header-images/casino.svg": 19338,
	"./assets/img/header-images/crash-games.png": 10062,
	"./assets/img/header-images/cricket.jpg": 20100,
	"./assets/img/header-images/cricket.svg": 41980,
	"./assets/img/header-images/darts.png": 55107,
	"./assets/img/header-images/darts.svg": 54775,
	"./assets/img/header-images/default.png": 24978,
	"./assets/img/header-images/evolution-logo-2.png": 22385,
	"./assets/img/header-images/floorball.jpg": 76408,
	"./assets/img/header-images/floorball.svg": 75048,
	"./assets/img/header-images/handball.jpg": 31417,
	"./assets/img/header-images/handball.svg": 16915,
	"./assets/img/header-images/help.jpg": 5012,
	"./assets/img/header-images/home.png": 35384,
	"./assets/img/header-images/home.svg": 74150,
	"./assets/img/header-images/icehockey.jpg": 78323,
	"./assets/img/header-images/icehockey.svg": 9095,
	"./assets/img/header-images/jackpot.jpg": 37719,
	"./assets/img/header-images/jackpot.svg": 47627,
	"./assets/img/header-images/league.svg": 59996,
	"./assets/img/header-images/liginare.png": 81928,
	"./assets/img/header-images/live.svg": 72873,
	"./assets/img/header-images/livescore.svg": 17941,
	"./assets/img/header-images/mma.svg": 73954,
	"./assets/img/header-images/print.jpg": 97476,
	"./assets/img/header-images/print.svg": 98516,
	"./assets/img/header-images/promos.svg": 66063,
	"./assets/img/header-images/rugby.svg": 74448,
	"./assets/img/header-images/soccer.png": 63088,
	"./assets/img/header-images/soccer.svg": 73198,
	"./assets/img/header-images/sport.svg": 52691,
	"./assets/img/header-images/sports.svg": 65370,
	"./assets/img/header-images/sure-league.jpg": 24630,
	"./assets/img/header-images/sure-live.png": 12739,
	"./assets/img/header-images/sureturbo.png": 24704,
	"./assets/img/header-images/table-tennis.svg": 23343,
	"./assets/img/header-images/tennis.svg": 43762,
	"./assets/img/header-images/virtual.svg": 62024,
	"./assets/img/header-images/virtuals.svg": 36635,
	"./assets/img/header-images/volleyball.png": 82401,
	"./assets/img/header-images/volleyball.svg": 34655,
	"./assets/img/hipo.png": 56682,
	"./assets/img/iceland.png": 42036,
	"./assets/img/italy.png": 64319,
	"./assets/img/laliga.png": 1983,
	"./assets/img/loader-old.gif": 96782,
	"./assets/img/logo.png": 65549,
	"./assets/img/logo.svg": 67503,
	"./assets/img/logo2 (2).png": 53916,
	"./assets/img/logo2.png": 93131,
	"./assets/img/mobile/APPDownload.png": 17702,
	"./assets/img/mpesa-1.png": 11396,
	"./assets/img/mpesa-3.png": 69718,
	"./assets/img/mpesa.png": 87806,
	"./assets/img/norway.png": 33566,
	"./assets/img/padlock.png": 96348,
	"./assets/img/ring.gif": 80857,
	"./assets/img/rugby-mobile.png": 61804,
	"./assets/img/rugby.png": 26295,
	"./assets/img/seriea.png": 86457,
	"./assets/img/spain.png": 86209,
	"./assets/img/sure.png": 50363,
	"./assets/img/svgicons/americanfootball.svg": 53148,
	"./assets/img/svgicons/app.svg": 49970,
	"./assets/img/svgicons/aussie.svg": 80407,
	"./assets/img/svgicons/aviator.svg": 96273,
	"./assets/img/svgicons/baseball.svg": 51629,
	"./assets/img/svgicons/basketball.svg": 17532,
	"./assets/img/svgicons/boxing.svg": 83444,
	"./assets/img/svgicons/casino.svg": 57168,
	"./assets/img/svgicons/cricket.svg": 84158,
	"./assets/img/svgicons/darts.svg": 50201,
	"./assets/img/svgicons/default.png": 29765,
	"./assets/img/svgicons/floorball.svg": 15726,
	"./assets/img/svgicons/handball.svg": 19337,
	"./assets/img/svgicons/home.svg": 70640,
	"./assets/img/svgicons/icehockey.svg": 7473,
	"./assets/img/svgicons/jackpot.svg": 88245,
	"./assets/img/svgicons/league.svg": 6798,
	"./assets/img/svgicons/livescore.svg": 35120,
	"./assets/img/svgicons/livescore1.svg": 15112,
	"./assets/img/svgicons/mma.svg": 20044,
	"./assets/img/svgicons/print.svg": 41502,
	"./assets/img/svgicons/promos.svg": 10981,
	"./assets/img/svgicons/rugby.svg": 21398,
	"./assets/img/svgicons/soccer.svg": 38760,
	"./assets/img/svgicons/sports.svg": 14632,
	"./assets/img/svgicons/surecoin.svg": 91981,
	"./assets/img/svgicons/tennis.svg": 7604,
	"./assets/img/svgicons/virtuals.svg": 85901,
	"./assets/img/svgicons/volleyball.svg": 79209,
	"./assets/img/todays.png": 66046,
	"./assets/img/ucl.png": 74566,
	"./assets/img/uefa.png": 3769,
	"./assets/logo.png": 33153,
	"./assets/logo.svg": 63935,
	"./assets/svg/2316003_ball_courts_football_sports_icon.svg": 38365,
	"./assets/svg/24-hours-delivery.svg": 51764,
	"./assets/svg/24-hours.svg": 20971,
	"./assets/svg/403.svg": 48442,
	"./assets/svg/404.svg": 55621,
	"./assets/svg/500.svg": 44416,
	"./assets/svg/503.svg": 89075,
	"./assets/svg/American Football.svg": 11696,
	"./assets/svg/Aussie Rules.svg": 70752,
	"./assets/svg/Badminton.svg": 35987,
	"./assets/svg/Bandy.svg": 43415,
	"./assets/svg/Baseball.svg": 35655,
	"./assets/svg/Basketball 3x3.svg": 62306,
	"./assets/svg/Basketball.svg": 24258,
	"./assets/svg/Beach Soccer.svg": 18109,
	"./assets/svg/Beach Volley.svg": 7903,
	"./assets/svg/Biathlon.svg": 4752,
	"./assets/svg/Bowls.svg": 16526,
	"./assets/svg/Boxing.svg": 41274,
	"./assets/svg/Chess-board (1).svg": 96052,
	"./assets/svg/Chess-board.svg": 77002,
	"./assets/svg/Chess.svg": 73869,
	"./assets/svg/Chess1.svg": 84614,
	"./assets/svg/Counter-Strike.svg": 6688,
	"./assets/svg/Cricket.svg": 77120,
	"./assets/svg/Cricket_ball_icon.svg": 4292,
	"./assets/svg/Cricket_ball_icon2.svg": 95838,
	"./assets/svg/Curling.svg": 54759,
	"./assets/svg/Cycling.svg": 38670,
	"./assets/svg/Darts.svg": 24907,
	"./assets/svg/Dota 2.svg": 29355,
	"./assets/svg/Field hockey.svg": 38216,
	"./assets/svg/Fifa.svg": 14787,
	"./assets/svg/Floorball.svg": 4620,
	"./assets/svg/Futsal.svg": 5564,
	"./assets/svg/Gaelic Football.svg": 72871,
	"./assets/svg/Gaelic Hurling.svg": 32769,
	"./assets/svg/Golf.svg": 86915,
	"./assets/svg/Handball.svg": 62863,
	"./assets/svg/Hockey.svg": 79400,
	"./assets/svg/Home.svg": 15994,
	"./assets/svg/Ice Hockey.svg": 63155,
	"./assets/svg/JP.svg": 9237,
	"./assets/svg/Kabaddi.svg": 80681,
	"./assets/svg/King of Glory.svg": 23838,
	"./assets/svg/League of Legends.svg": 62833,
	"./assets/svg/Live.svg": 7917,
	"./assets/svg/MMA.svg": 81078,
	"./assets/svg/Motor-sport.svg": 14879,
	"./assets/svg/Overwatch.svg": 68370,
	"./assets/svg/Pesapallo.svg": 68826,
	"./assets/svg/Promotions.svg": 15305,
	"./assets/svg/Racing.svg": 40622,
	"./assets/svg/Racing3.svg": 22480,
	"./assets/svg/Rally.svg": 78965,
	"./assets/svg/Rugby.svg": 15908,
	"./assets/svg/Snooker.svg": 57552,
	"./assets/svg/Soccer.svg": 31210,
	"./assets/svg/Speedway.svg": 35165,
	"./assets/svg/Squash.svg": 36292,
	"./assets/svg/StarCraft.svg": 67135,
	"./assets/svg/Stock Car Racing.svg": 10513,
	"./assets/svg/Swimming.svg": 4216,
	"./assets/svg/Swimming2.svg": 19290,
	"./assets/svg/Table Tennis.svg": 30246,
	"./assets/svg/Tenis ball.svg": 97251,
	"./assets/svg/Tennis.svg": 58318,
	"./assets/svg/Tennis2.svg": 97440,
	"./assets/svg/Valorant.svg": 55430,
	"./assets/svg/Volleyball.svg": 42019,
	"./assets/svg/Waterpolo.svg": 65972,
	"./assets/svg/car.svg": 4011,
	"./assets/svg/default_sport.svg": 37686,
	"./assets/svg/dragster-svgrepo-com.svg": 92920,
	"./assets/svg/facebook-logo.svg": 52025,
	"./assets/svg/filter-icon.svg": 3993,
	"./assets/svg/football.svg": 16392,
	"./assets/svg/hipo.png": 94327,
	"./assets/svg/magnifier.svg": 34309,
	"./assets/svg/old-typical-phone.svg": 93306,
	"./assets/svg/opened-email-envelope.svg": 61076,
	"./assets/svg/padlock.svg": 70031,
	"./assets/svg/search-icon.svg": 37863,
	"./assets/svg/sure.png": 51354,
	"./assets/svg/tennis-ball.svg": 61772,
	"./assets/svg/toggle-off-icon.svg": 65851,
	"./assets/svg/twitter-logo-on-black-background.svg": 3185,
	"./assets/team-jersies/away-default.png": 73350,
	"./assets/team-jersies/home-default.png": 93749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15353;